import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import TestimonialsList from './TestimonialsList'
import PageSEO from '../shared/PageSEO'

const Testimonials = () => {
  const { t } = useTranslation()

  return (
    <>
      <PageSEO 
        title="Testimonials | Hyunjin Jae"
        description="Read what others have to say about working with Hyunjin Jae, a software developer specializing in full stack development."
        keywords="testimonials, references, software developer, web development, client feedback"
        tags={['testimonials', 'references', 'feedback']}
      />
      <Box
        sx={{
          maxWidth: '900px',
          mx: 'auto'
        }}
      >
        <TestimonialsList />
        <Typography
          variant="body1"
          sx={{
            mb: 2,
            textAlign: 'left',
            fontSize: '15px',
            lineHeight: 1.5,
            maxWidth: '740px',
            color: 'text.secondary',
            fontStyle: 'italic'
          }}
        >
          {t('testimonials:intro')}
        </Typography>
      </Box>
    </>
  )
}

export default Testimonials